if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.remoteSubmitButtons = document.querySelectorAll(`button[form="${this.form.getAttribute('id')}"]`);

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.checkmarkDuration = parseInt(this.dataset.checkmarkDuration || 0);
      }

      remoteSubmitButtonsLoop(event, text) {
        if(!event) return;

        this.remoteSubmitButtons.forEach((btn) => {
          const soldOutMessage = btn.querySelector('.sold-out-message');
          const submitButtonText = btn.querySelector('span');
          if(event === 'onSubmitHandler') {
            btn.setAttribute('aria-disabled', true);
            btn.classList.add('loading');
            btn.querySelector('.loading__spinner').classList.remove('hidden');
          }
          if(event === 'onSubmitHandler:error') {
            if(soldOutMessage) {
              btn.setAttribute('aria-disabled', true);
              submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
          }
          if(event === 'onSubmitHandler:finally') {
            btn.querySelector('.loading__spinner').classList.add('hidden');
            if (!this.error) {
              btn.querySelector('.loading__checkmark').classList.remove('hidden');
              setTimeout(() => {
                btn.removeAttribute('aria-disabled');
                btn.classList.remove('loading');
                btn.querySelector('.loading__checkmark').classList.add('hidden');
              }, 2000);
            } else {
              btn.classList.remove('loading');
            }
          }
          if(event === 'toggleSubmitButton:disable') {
            btn.setAttribute('disabled', 'disabled');
            if (text) submitButtonText.textContent = text;
          }
          if(event === 'toggleSubmitButton:enable') {
            btn.removeAttribute('disabled');
            submitButtonText.textContent = window.variantStrings.addToCart;
          }
        });

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.remoteSubmitButtons.length > 0 && Array.from(this.remoteSubmitButtons).find(btn => btn.getAttribute('aria-disabled') === 'true')) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        this.remoteSubmitButtonsLoop('onSubmitHandler');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              this.remoteSubmitButtonsLoop('onSubmitHandler:error');

              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (!this.error) {
              if(this.checkmarkDuration > 0) {
                this.querySelector('.loading__checkmark').classList.remove('hidden');
                setTimeout(() => {
                  this.submitButton.removeAttribute('aria-disabled');
                  this.submitButton.classList.remove('loading');
                  this.querySelector('.loading__checkmark').classList.add('hidden');
                }, this.checkmarkDuration * 1000);
              } else {
                this.submitButton.removeAttribute('aria-disabled');
                this.submitButton.classList.remove('loading');
              }
            } else {
              this.submitButton.classList.remove('loading');
            }
            this.remoteSubmitButtonsLoop('onSubmitHandler:finally');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          this.remoteSubmitButtonsLoop('toggleSubmitButton:disable', text);
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.remoteSubmitButtonsLoop('toggleSubmitButton:enable');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
